























import { computed, defineComponent, ref, toRef, watch } from "@vue/composition-api";
import useBalance from "@/hooks/useBalance";
import useOnChangePage from "@/hooks/useOnChangePage";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "PaidActionConfirm",
  components: { BaseCheckbox, BaseIcon, BaseButton, BaseConfirm, FormatMoney },
  props: {
    value: { type: Boolean, required: true },
    price: { type: Number, required: true },
    allowDoNotShowAgain: { type: Boolean, default: false },
    priceChangedText: { type: String, default: "" },
  },
  setup(props, { emit }) {
    const { balance } = useBalance();
    const onAddMoney = () => emitter.emit(EVENTS.BALANCE_REFILL_SHOW);

    useOnChangePage(() => emit("input", false));

    const showPriceChangedText = ref(false);
    const dontShowAgain = ref(false);
    const dontShowAgainVisual = ref(false);
    watch(toRef(props, "value"), newVal => {
      if (newVal && (dontShowAgain.value || props.price === 0)) {
        emit("input", true);
      }
      if (!newVal) {
        showPriceChangedText.value = false;
      }
    });
    watch(toRef(props, "price"), () => {
      if (!dontShowAgain.value) {
        return;
      }
      dontShowAgain.value = dontShowAgainVisual.value = false;
      showPriceChangedText.value = true;
    });
    const onSubmit = () => {
      dontShowAgain.value = dontShowAgainVisual.value;
      emit("input", true);
    };
    const onCancel = () => {
      dontShowAgain.value = dontShowAgainVisual.value = false;
      emit("input", false);
    };
    const titleText = computed(() => (showPriceChangedText.value ? props.priceChangedText : ""));

    return {
      balance,
      onAddMoney,
      dontShowAgain,
      dontShowAgainVisual,
      titleText,
      onCancel,
      onSubmit,
    };
  },
});
